import { apiCall } from "./service";
import { URL_PROJECT_INVOICE_REGISTRY, URL_INVOICE_REGISTRY } from "./URL";

export const api = {
  sortInvoiceRegistryRequest(params) {
    return apiCall.pagination({
      url: `${URL_PROJECT_INVOICE_REGISTRY(params.id)}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
      isAuthToken: true,
    });
  },

  getInvoiceRegistriesRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = URL_PROJECT_INVOICE_REGISTRY(params.id);

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  fetchSingleInvoiceRegistryRequest(id) {
    return apiCall.get({ url: `${URL_INVOICE_REGISTRY}${id}` });
  },

  createInvoiceRegistryRequest(params) {
    return apiCall.post({
      url: `${URL_INVOICE_REGISTRY}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateInvoiceRegistryRequest(params) {
    return apiCall.put({
      url: `${URL_INVOICE_REGISTRY}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteInvoiceRegistryRequest(params) {
    return apiCall.delete({
      url: `${URL_INVOICE_REGISTRY}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  updateInvoiceRegistryFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_INVOICE_REGISTRY}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  updateInvoiceRegistryInLedgerStatus(invoiceId, isInLedger) {
      return apiCall.put({
        url: `${URL_INVOICE_REGISTRY}${invoiceId}/ledger-status`,
        isAuthToken: true,
        params: { isInLedger },
      });
    },
};

export default api;
